module.exports = __webpack_public_path__ + "img/stop.877cc935.png";